import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";

import { LoginComponent } from "./login/login.component";
import { UserRoutingModule } from "./user.routing.module";

import { NgZorroAntdModule } from "ng-zorro-antd";
import { LoginService } from "../service/login/login.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    NgZorroAntdModule,
    ReactiveFormsModule,
    UserRoutingModule
  ],
  declarations: [LoginComponent],
  providers: []
})
export class UserModule {}
